import { ClientEventRow } from '@entities/clients';
import { FilterItem } from '../SearchCheckboxFilterDropdown';
import { ClientTableFilterItems } from './types';

const toFilterItems = (names: Iterable<string>): FilterItem<string>[] =>
  [...new Set(names)].sort().map((name) => ({ value: name, label: name }));

export const buildEventClientsFilterItems = (rows: ClientEventRow[]): ClientTableFilterItems => {
  const brokerNames = new Set<string>();
  const allManagerNames = new Set<string>();
  const invitingManagerNames = new Set<string>();

  for (const row of rows) {
    row.brokers.forEach((name) => brokerNames.add(name));
    allManagerNames.add(row.salesManager);
    allManagerNames.add(row.invitingManager);
    invitingManagerNames.add(row.invitingManager);
  }

  return {
    brokerFilterItems: toFilterItems(brokerNames),
    allManagerFilterItems: toFilterItems(allManagerNames),
    invitingManagerFilterItems: toFilterItems(invitingManagerNames),
  };
};
